import React, {FC} from "react";
import {TwoWheeler} from "@mui/icons-material";
import {Box} from "@mui/material";

interface MainImageProps {
    src: string;
    alt: string;
    onError: () => void;
    error: boolean;
    onClick?: () => void;
    sx?: object;
}

export const MainImage: FC<MainImageProps> = ({src, alt, onError, error, onClick, sx}) => {
    return error ? (
        <TwoWheeler sx={{fontSize: "4rem", color: "#ccc"}}/>
    ) : (
        <Box
            component="img"
            src={src}
            alt={alt}
            onError={onError}
            onClick={onClick}
            sx={sx}
        />
    );
};
